import React from 'react'
import PropTypes from 'prop-types'

import YesNo from 'components/UI/YesNo/YesNo'
import Link from 'components/Link'
import FileImage from 'components/UI/FileImage/FileImage'

import './event-attachments-item.pcss'

class EventAttachmentsItem extends React.PureComponent {
    render () {
        const { attachment, onRemove } = this.props

        return (
            <div className="event-attachments-item">
                <FileImage
                    imageUrl={attachment.thumbUrl}
                    fileName={attachment.filename}
                    mediaType={attachment.mediatype}
                    size="s"
                />
                <Link
                    to={attachment.attachmentUrl}
                    className="event-attachments-item__name"
                    trackName="attachment"
                >
                    {attachment.filename}
                </Link>
                <div className="event-attachments-item__actions">
                    <YesNo
                        startText="Poista"
                        startTrackName="delete"
                        yesText="Poista"
                        onYes={onRemove}
                        yesTrackName="confirmDelete"
                        noText="Peruuta"
                        noTrackName="cancelDelete"
                    />
                </div>
            </div>
        )
    }
}

EventAttachmentsItem.propTypes = {
    attachment: PropTypes.shape({
        id: PropTypes.string.isRequired,
        filename: PropTypes.string.isRequired,
        mediatype: PropTypes.string.isRequired,
        attachmentUrl: PropTypes.string.isRequired,
        thumbUrl: PropTypes.string,
    }).isRequired,
    onRemove: PropTypes.func.isRequired,
}

export default EventAttachmentsItem
